import { InspectionModel } from 'shared/domain/inspection/inspectionModel';
import {
  isComplianceProtocolAnswer,
  ProtocolAnswer,
} from 'shared/domain/protocolAnswer';
import { protocolAnswerInDtoToProtocolAnswer } from 'shared/domain/protocolAnswer/protocolAnswerInDtoToProtocolAnswer';
import { ProtocolAnswerInDto } from 'shared/dtos/in/protocolAnswer';
import { areObjectIdsEqual } from 'helpers/idComparison';

export function mergeProtocolAnswerIntoInspectionModel(
  inspection: InspectionModel,
  protocolItemId: string,
  answerInDto: ProtocolAnswerInDto
): InspectionModel {
  const normalizedAnswer = protocolAnswerInDtoToProtocolAnswer(answerInDto);

  return {
    ...inspection,
    protocol: inspection.protocol.map((protocolItem) => {
      if (!areObjectIdsEqual(protocolItem._id, protocolItemId)) {
        return protocolItem;
      }

      const answers = [...(protocolItem.answers || [])];
      const answerIndex = answers.findIndex((answer) =>
        areObjectIdsEqual(answer._id, normalizedAnswer._id)
      );

      if (answerIndex === -1) {
        answers.push(normalizedAnswer);
      } else {
        answers[answerIndex] = mergeProtocolAnswers(
          answers[answerIndex],
          normalizedAnswer
        );
      }

      let complianceCheck = protocolItem.complianceCheck;
      if (
        isComplianceProtocolAnswer(normalizedAnswer) &&
        normalizedAnswer.selectedOption !== undefined
      ) {
        complianceCheck = {
          ...complianceCheck,
          result: normalizedAnswer.selectedOption,
        };
      }

      return {
        ...protocolItem,
        answers,
        complianceCheck,
      };
    }),
  };
}

function mergeProtocolAnswers(
  existing: ProtocolAnswer,
  updated: ProtocolAnswer
): ProtocolAnswer {
  return {
    ...existing,
    ...updated,
  };
}
